import BasicEmailAlert from './BasicEmailAlert'

export default BasicEmailAlert
